import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router';
import urls from '../../app/urls';

const RedirectIfNoLicense = () => {
    const profileData = useSelector(state => state.auth.profileData);

    if (!profileData) {
        return null;
    }

    if (!profileData.license) {
        return <Redirect to={urls.inside.home} />;
    }

    return null;
};

export default RedirectIfNoLicense;
